import React, { useCallback, useState } from 'react';

import { cssMap } from '@atlaskit/css';
import ModalTransition from '@atlaskit/modal-dialog/modal-transition';
import { Flex } from '@atlaskit/primitives/compiled';

import type { CardsActions } from '../../../../controllers/use-cards-extension-parameters-and-actions/types';
import type { CardsExtensionParameters, Filters } from '../../../../types';
import { DynamicCardsContent } from './dynamic-cards-content';
import { DynamicContentModal } from './dynamic-content-modal';
import { EmptyStateContainer } from './empty-state-container';

const styles = cssMap({
	disabledContentWrapper: {
		cursor: 'not-allowed',
	},
});

type DynamicVariantContentProps = {
	extensionActions: CardsActions;
	extensionParameters: CardsExtensionParameters;
	isDisabled: boolean;
};

export const DynamicVariantContent = ({
	extensionParameters,
	extensionActions,
	isDisabled,
}: DynamicVariantContentProps): React.JSX.Element => {
	const { filters } = extensionParameters;
	const { updateMainFormField } = extensionActions;

	const hasFilters = !!filters;

	const [isDynamicContentModalOpen, setIsDynamicContentModalOpen] = useState(false);
	const handleCloseModal = useCallback(() => setIsDynamicContentModalOpen(false), []);
	const handleOpenModal = useCallback(() => setIsDynamicContentModalOpen(true), []);

	const handleSetFilters = (newFilters: Filters) => {
		updateMainFormField({ filters: newFilters });
	};

	return (
		<>
			<Flex direction="column" gap="space.300" xcss={isDisabled && styles.disabledContentWrapper}>
				{hasFilters ? (
					<DynamicCardsContent
						viewFilters={handleOpenModal}
						extensionParameters={extensionParameters}
						extensionActions={extensionActions}
					/>
				) : (
					<EmptyStateContainer startCreateFilters={handleOpenModal} />
				)}
			</Flex>
			<ModalTransition>
				{isDynamicContentModalOpen && (
					<DynamicContentModal
						filters={filters}
						closeModal={handleCloseModal}
						setFilters={handleSetFilters}
					/>
				)}
			</ModalTransition>
		</>
	);
};
